// Module
var code = "<template>\n  <button disabled.bind=\"disabled\" class=\"button button--smaller button--ghost button--new\"\n    class.bind=\"classes + ' ' + styleClasses\" click.delegate=\"onClick()\">\n    <slot></slot>\n  </button>\n</template>\n";
// Exports
export default code;